import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { requestHandler } from '../helper';
import { toast } from 'react-toastify';
import { passwordChange } from '../controller';

function UserChangePassword() {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');

    const togglePasswordVisibility1 = () => {
        setShowNewPassword(!showNewPassword);
    };
    const togglePasswordVisibility2 = () => {
        setShowConfirmNewPassword(!showConfirmNewPassword);
    };
    const togglePasswordVisibility3 = () => {
        setShowCurrentPassword(!showCurrentPassword);
    };

    const handleSubmit = async(e) => {
        e.preventDefault();

        if(newPassword !== confirmNewPassword) {
            toast.error("Password and confirm password does not match");
            return;
        }
        await requestHandler(
            async () => await passwordChange({ currentPassword, newPassword}),
            null,
            (res) => {
                setCurrentPassword("")
                setNewPassword("")
                setConfirmNewPassword("")
                toast.success(res.message);
                handleClose()
            },
            () => {}
        );
    }


    return (
        <>

            <div className='d-flex align-items-center gap-2' onClick={handleShow}>
                <img src="../images/png/password.png" width={34.47} height={34.47} alt="" />
                Password
            </div>

            <Modal className='modal-main' show={show} centered size='md' onHide={handleClose}>
                <Modal.Body>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Change Password</h2>
                            </div>
                        </div>
                    </Modal.Title>
                    <div className='modal-form'>
                        <Form>
                            <Form.Group className="mb-3" controlId="formGroupPassword1">
                                <Form.Label>Current Password</Form.Label>
                                <div className='form-control d-flex align-items-center ps-0 py-0'>
                                    <Form.Control
                                        type={showCurrentPassword ? 'text' : 'password'}
                                        placeholder="Enter Current Password"
                                        className='input-border-0'
                                        value={currentPassword}
                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                    />
                                    <img
                                        width={22}
                                        src={showCurrentPassword ? "../images/png/show-eye.png" : "../images/png/close-eye.png"}
                                        alt=""
                                        style={{ cursor: 'pointer' }}
                                        onClick={togglePasswordVisibility3}
                                    />
                                </div>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupPassword1">
                                <Form.Label>New Password</Form.Label>
                                <div className='form-control d-flex align-items-center ps-0 py-0'>
                                    <Form.Control
                                        type={showNewPassword ? 'text' : 'password'}
                                        placeholder="Enter New Password"
                                        className='input-border-0'
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                    />
                                    <img
                                        width={22}
                                        src={showNewPassword ? "../images/png/show-eye.png" : "../images/png/close-eye.png"}
                                        alt=""
                                        style={{ cursor: 'pointer' }}
                                        onClick={togglePasswordVisibility1}
                                    />
                                </div>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupPassword2">
                                <Form.Label>Confirm Password</Form.Label>
                                <div className='form-control d-flex align-items-center ps-0 py-0'>
                                    <Form.Control
                                        type={showConfirmNewPassword ? 'text' : 'password'}
                                        placeholder="Enter Confirm Password"
                                        className='input-border-0'
                                        value={confirmNewPassword}
                                        onChange={(e) => setConfirmNewPassword(e.target.value)}
                                    />
                                    <img
                                        width={22}
                                        src={showConfirmNewPassword ? "../images/png/show-eye.png" : "../images/png/close-eye.png"}
                                        alt=""
                                        style={{ cursor: 'pointer' }}
                                        onClick={togglePasswordVisibility2}
                                    />
                                </div>
                            </Form.Group>
                            <div className='d-md-flex align-items-center gap-3 mt-4'>
                                <button className='cancel-btn' onClick={handleClose} type='button' onHide={handleClose}>Cancel</button>
                                <button className='save-btn' onClick={handleSubmit}>Save</button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UserChangePassword